module.exports = __webpack_public_path__ + "img/send parcel.68de80c2.svg";